<template>
  <FlexRow align="baseline" class="my-2">
    <FlexColumn v-if="label" class="mr-4">
      {{label}}
    </FlexColumn>
    <Card outlined>
      <FlexColumn
        v-for="(column, index) in columns"
        :key="`item-select-field-${index}`"
      >
        <FlexRow>
          <Button
            v-for="item in column"
            :key="`item-select-field-${index}-${item.value}`"
            :color="color(item.value)"
            :class="buttonClasses"
            style="pointer-events: none;"
          >
            {{ item.label }}
          </Button>
        </FlexRow>
      </FlexColumn>
    </Card>
  </FlexRow>
</template>

<script>
import FlexColumn from '@/components/atoms/FlexColumn'
import FlexRow from '@/components/atoms/FlexRow'
import Button from '@/components/atoms/Button'
import Card from '@/components/atoms/Card'

export default {
  name: 'ItemSelect',
  components: {
    Card,
    FlexColumn,
    FlexRow,
    Button,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    value: {
      type: Number,
      default: undefined,
    },
    label: {
      type: String,
      default: undefined,
    }
  },
  data() {
    return {
    }
  },
  computed: {
    columns() {
      const items = [...this.items]
      const list = []
      for (let index = 0; index < items.length; index += 3) {
        list.push(items.slice(index, index + 3))
      }
      return list
    },
    color() {
      return (value) => {
        if (value === this.value) {
          return 'info'
        }
        return 'rgba(0,0,0,0)'
      }
    },
    buttonClasses() {
      const classes = ['button', 'flex-grow-1']
      if (this.items.length < 3) {
        classes.push('item2')
      } else {
        classes.push('item3')
      }
      return classes
    },
  },
  methods: {},
}
</script>

<style scoped lang="sass">
.button
  &.item2
    min-width: calc((100% - 8px) / 2)
    max-width: calc((100% - 8px) / 2)
  &.item3
    min-width: calc((100% - 16px) / 3)
    max-width: calc((100% - 16px) / 3)

  &:active
    font-weight: 300

</style>
